// extracted by mini-css-extract-plugin
export default {"productCallout":"xba-z"};